<template>
  <el-dialog
    v-model="visible"
    title="生命周期"
    width="800px"
    :close-on-click-modal="false"
    body-class="lifecycle-dialog"
  >
    <div class="lifecycle">
      <div class="baseInfo">
        <div class="title">
          {{
            baseInfo.materialName +
            "&nbsp;&nbsp;&nbsp;" +
            "(表具编号：" +
            baseInfo.number +
            ")"
          }}
        </div>
        <div class="content">
          <span class="label"
            >物料编号： {{ baseInfo.materialNumber || "-" }}</span
          >
          <span class="label"
            >物料类别：{{ baseInfo.materialCategoryName || "-" }}</span
          >
          <span class="label"
            >规格型号：{{ baseInfo.materialModel || "-" }}</span
          >
        </div>
      </div>

      <el-divider></el-divider>

      <el-timeline class="timeline">
        <el-timeline-item
          :hide-timestamp="true"
          v-for="item in timelineInfo"
          :key="item.id"
          color="#0052d9"
        >
          <div class="item">
            <div class="title">
              <span class="name">{{ getNameByType(item.type).nameDict }}</span>
              <span class="time">{{
                "(" + getNameByType(item.type).timeDict + item.msg.time + ")"
              }}</span>
            </div>
            <div class="content" v-if="item.type === 10">
              <div class="label">入库人：{{ item.msg.boundUserName }}</div>
              <div class="label">
                入库部门：{{ item.msg.requestDepartmentName }}
              </div>
              <div class="label">入库仓库：{{ item.msg.warehouseName }}</div>
              <div class="label">入库单号：{{ item.msg.number }}</div>
            </div>
            <div class="content" v-if="item.type === 20">
              <div class="label">出库人：{{ item.msg.boundUserName }}</div>
              <div class="label">
                出库部门：{{ item.msg.requestDepartmentName }}
              </div>
              <div class="label">出库仓库：{{ item.msg.warehouseName }}</div>
              <div class="label">出库单号：{{ item.msg.number }}</div>
            </div>
            <div class="content" v-if="item.type === 30">
              <div class="label">负责人：{{ item.msg.personInCharge }}</div>
              <div class="label">安装具体位置：{{ item.msg.address }}</div>
            </div>
            <div class="content" v-if="item.type === 40">
              <div class="label">更换前点编码：{{ item.msg.pointCode }}</div>
              <div class="label">更换具体位置：{{ item.msg.address }}</div>
            </div>
            <div class="content" v-if="item.type === 50">
              <div class="label">报废人：{{ item.msg.scrapPerson }}</div>
            </div>
            <div class="content" v-if="item.type === 60">
              <div class="label">入库人：{{ item.msg.scrapInPerson }}</div>
              <div class="label">入库仓库：{{ item.msg.warehouseName }}</div>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";

const visible = ref(false); // 弹窗控制

const loading = ref(false); // 遮罩
const baseInfo = ref(false); // 基础信息
const timelineInfo = ref(false); // 生命周期信息

// 弹窗打开
const handleDialogOpen = (row, data) => {
  console.log("传入数据1===>", row);
  console.log("传入数据2===>", data);

  baseInfo.value = row;
  timelineInfo.value = data;

  visible.value = true;
};
const getNameByType = (type) => {
  let nameDict = "";
  let timeDict = "";
  switch (type) {
    case 10:
      nameDict = "入库-采购入库";
      timeDict = "入库时间：";
      break;
    case 20:
      nameDict = "出库-工程用料";
      timeDict = "出库时间：";
      break;
    case 30:
      nameDict = "报装管理-施工安装";
      timeDict = "安装时间：";
      break;
    case 40:
      nameDict = "管网更换-水表更换";
      timeDict = "更换时间：";
      break;
    case 50:
      nameDict = "报废时间";
      timeDict = "报废时间：";
      break;
    case 60:
      nameDict = "入库-报废入库";
      timeDict = "报废入库时间：";
      break;
  }
  return {
    nameDict,
    timeDict,
  };
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style lang="less" scoped>
.lifecycle {
  .baseInfo {
    .title {
      font-weight: 700;
      font-size: 18px;
      color: #3478f6;
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      align-content: center;
      justify-content: space-between;
      padding-right: 20px;
      .label {
        font-size: 14px;
        color: #aaaaaafe;
      }
    }
  }
  .timeline {
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }
    .item {
      width: 100%;
      .title {
        width: 100%;
        margin-bottom: 10px;
        display: flex;
        .name {
          font-weight: 700;
          font-size: 14px;
          color: #0052d9;
        }
        .time {
          font-size: 12px;
          color: #ed7b2f;
          margin-left: 20px;
        }
      }
      .content {
        width: 100%;
        label {
          width: 100%;
          font-size: 14px;
          color: #333333;
          margin-block: 0.3125rem;
        }
      }
    }
  }
}
</style>
<style>
.lifecycle-dialog {
  padding-top: 0px;
}
</style>
